import { render, staticRenderFns } from "./IconLike2.vue?vue&type=template&id=22722180"
import script from "./IconLike2.vue?vue&type=script&lang=js"
export * from "./IconLike2.vue?vue&type=script&lang=js"
import style0 from "./IconLike2.vue?vue&type=style&index=0&id=22722180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports